import type { BadgeDesignTokens } from '@primeuix/themes/types/badge'
import type { ChipDesignTokens } from '@primeuix/themes/types/chip'
import type { TagDesignTokens } from '@primeuix/themes/types/tag'

import { bothSchemes } from '../utils'

/** Чипсы категорий («Салаты», «Хот-доги») и веса («390 г»). */
export const chipConfig = (): ChipDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-pill)',
    paddingX: 'var(--space-6)',
    paddingY: 'var(--space-3)',
    gap: 'var(--space-4)',
    transitionDuration: '.15s',
  },
  icon: {
    size: '20px',
  },
  image: {
    width: '30px',
    height: '30px',
  },
  removeIcon: {
    size: '16px',
    focusRing: { width: '0', style: 'none', offset: '0' },
  },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-muted)',
      color: 'var(--text-color)',
    },
    icon: { color: 'var(--icon-color)' },
    removeIcon: { color: 'var(--icon-color)' },
  }),
})

/** Бейджи «sale» / «new» на карточках товара и счётчик в bottom nav. */
export const badgeConfig = (): BadgeDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-pill)',
    padding: '0 var(--space-3)',
    fontSize: '10px',
    fontWeight: 'var(--fw-bold)',
    minWidth: '18px',
    height: '18px',
  },
  dot: {
    size: '8px',
  },
  colorScheme: bothSchemes({
    primary: { background: 'var(--primary-500)', color: 'var(--white)' },
    secondary: { background: 'var(--accent-500)', color: 'var(--accent-surface-color)' },
    success: { background: 'var(--success-500)', color: 'var(--white)' },
    info: { background: 'var(--info-500)', color: 'var(--white)' },
    warn: { background: 'var(--accent-500)', color: 'var(--accent-surface-color)' },
    danger: { background: 'var(--primary-500)', color: 'var(--white)' },
    contrast: { background: 'var(--surface-inverse)', color: 'var(--text-color-inverse)' },
  }),
})

/** Статусы заказа («Принят», «Готовится», «Доставлен»). */
export const tagConfig = (): TagDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-pill)',
    padding: 'var(--space-1) var(--space-4)',
    gap: 'var(--space-2)',
    fontSize: '12px',
    fontWeight: 'var(--fw-bold)',
  },
  icon: {
    size: '14px',
  },
  colorScheme: bothSchemes({
    primary: { background: 'var(--accent-500)', color: 'var(--accent-surface-color)' },
    secondary: { background: 'var(--surface-muted)', color: 'var(--text-color)' },
    success: { background: 'rgb(14 169 0 / 15%)', color: 'var(--success-500)' },
    info: { background: 'rgb(1 124 250 / 15%)', color: 'var(--info-500)' },
    warn: { background: 'rgb(255 191 26 / 25%)', color: 'var(--text-color)' },
    danger: { background: 'var(--primary-500)', color: 'var(--white)' },
    contrast: { background: 'var(--surface-inverse)', color: 'var(--text-color-inverse)' },
  }),
})
